export default "__VITE_ASSET__BjSYne5m__"